"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.userIdsExtractor = void 0;
var userIdsExtractor = function (response) { return response.user_ids; };
exports.userIdsExtractor = userIdsExtractor;
//# sourceMappingURL=floating-inventories.consts.js.map